import { realBricksApi } from '../../utils/axiosInterceptors';

export const signUp = async (data, queryParams = {}) => {
  const queryString = Object.keys(queryParams).length > 0 
    ? '?' + new URLSearchParams(queryParams).toString() 
    : '';
  const response = await realBricksApi.post(`/api/v1/auth/signup${queryString}`, data);
  return response.data;
};

export const EmailValidate = async (email, token) => {
  const response = await realBricksApi.post(`/api/v1/auth/check-email-status`, { email }, {
    headers: {
      'email-api-auth': token
    }
  })
  return response;
}

export const createPinApi = async (pin) => {
  const response = await realBricksApi.post(`/api/v1/user/pin`, pin);
  return response.data;
};

export const resendEmailApi = async () => {
  const response = await realBricksApi.post(`/api/v1/user/resend-email`);
  return response.data;
};

export const validatePin = async (data) => {
  const response = await realBricksApi.post(`/api/v1/user/validate-pin`, data);
  return response.data;
};

export const getReferralLink = async (token) => {
  const response = await realBricksApi.get(`/api/v1/user/referral-link`, {
    headers: {
      Authorization: token
    }
  });
  return response.data;
}

export const pinAttemptCounter = async (token) => {
  const response = await realBricksApi.get(`/api/v1/user/pin-attempt-counter`, {
    headers: {
      Authorization: token
    }
  });
  return response.data;
}

export const login = async (data, loginType, remember) => {
  const response = await realBricksApi.post(`/api/v1/login?loginType=${loginType}&remember=${remember}`, data);
  return response.data;
};
